import type { IconData } from '@stacksjs/iconify-core'

export const gn4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"red\" d=\"M0 0h213.3v480H0z\"/><path fill=\"#ff0\" d=\"M213.3 0h213.4v480H213.3z\"/><path fill=\"#090\" d=\"M426.7 0H640v480H426.7z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default gn4x3
